import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { MbIconTextModule, MbIconModule } from '@am/moebius';

@Component({
    selector: 'payment-advise-info',
    templateUrl: './payment-advise-info.component.html',
    styleUrls: ['./payment-advise-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MbIconTextModule,
        NgSwitch,
        MbIconModule,
        NgSwitchCase,
    ],
})
export class PaymentAdviseInfoComponent implements OnInit {
  @Input()
  rate: any;
  @Input()
  isArgentina: boolean;
  @Input()
  isExperts: boolean;
  @Input()
  isCurrencyUSD: boolean;

  paymentText: string;

  constructor(private readonly cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.setPaymentText();
  }

  public setPaymentText() {
    this.paymentText = this.setText();
    this.cd.markForCheck();
  }

  private setText(): string {
    if (!this.rate.isBooking) {
      return this.notBookingPaymentText();
    }
    return this.isBookingPaymentText();
  }

  private isBookingPaymentText(): string {
    if (!this.rate.refundable) {
      return 'NOT_REFUNDABLE';
    }
    return this.depositRequiredPaymentText();
  }

  private depositRequiredPaymentText(): string {
    if (!this.rate.deposit_required) {
      return 'NOT_DEPOSIT_REQUIRED';
    }
    return 'DEPOSIT_REQUIRED';
  }

  private notBookingPaymentText(): string {
    if (!(this.rate.payment_method.code === 'PREPAID')) {
      return 'CREDIT_CARD';
    }
    return this.isArgentinianPaymentText();
  }

  private isArgentinianPaymentText(): string {
    if (!this.isArgentina) {
      if (this.isCurrencyUSD) {
        return 'NOT_ARGENTINIAN_USD';
      }
      return 'NOT_ARGENTINIAN';
    }
    return 'IS_ARGENTINIAN';
  }
}
